import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import EventDraftListItem from 'components/event-draft-list-item'
import { getSetupformUrl } from 'utils/urls'
import { STAGE_STATUS } from 'constants/setupform-constants'

import styles from './event-draft-list.css'

const EventDraftList = ({ events, partnerId, title, subtitle }) => (
  <div styleName="event-draft-list">
    <h2 styleName="title">{title}</h2>
    <h3 styleName="subtitle">{subtitle}</h3>

    {events.map((event, index) => (
      <EventDraftListItem
        key={index}
        name={event.name || 'Untitled'}
        setupformId={event.id}
        url={getSetupformUrl(
          partnerId,
          event.id,
          event.setupformDetailIsReadonly ? STAGE_STATUS.CALENDAR : STAGE_STATUS.BASIC_DETAILS
        )}
        externalUrl={event.setupformDetailIsReadonly}
      />
    ))}
  </div>
)

EventDraftList.propTypes = {
  events: PropTypes.array,
  partnerId: PropTypes.any,
  subtitle: PropTypes.string,
  title: PropTypes.string,
}

export default CSSModules(EventDraftList, styles)



/** WEBPACK FOOTER **
 ** ./src/components/event-draft-list/event-draft-list.js
 **/